/* ============================================================
   OBEE EXTRACTS — Verlosung (Messe)

   Zwei Wege in denselben Lostopf: Endkunden mit einer Adresse,
   Händler mit ihren Firmendaten. Der Händlerteil ist zugeklappt,
   damit das Fenster für die Mehrheit ein Feld und einen Knopf
   zeigt — sechs Pflichtfelder als Erstes würden am Stand mehr
   Teilnehmer kosten als sie bringen.

   Zeitpunkt: erst wenn die Altersabfrage weg ist, dann vier
   Sekunden. Die Bühne mit den zwei Taps soll den ersten Eindruck
   machen — sie ist am Stand der Aufhänger. Danach das Fenster.

   Wer wegklickt, bekommt unten links einen kleinen Knopf zurück.
   Ein Fehlklick auf dem Handy wäre sonst eine verlorene Teilnahme,
   und genau das passiert am Stand ständig.

   Der Versand läuft wie bei den anderen Formularen über ein
   unsichtbares Fenster zu Brevo. Wir sehen die Antwort nicht,
   also wird vorher geprüft, was sich prüfen lässt.
   ============================================================ */
(function () {
  'use strict';

  var box = document.getElementById('giveaway');
  if (!box) return;                       /* Aktion aus oder keine Formularadresse */

  var card   = box.querySelector('.gv-card');
  var form   = document.getElementById('gvForm');
  var tform  = document.getElementById('gvTradeForm');
  var reopen = document.getElementById('gvReopen');
  var terms  = box.querySelector('.gv-terms');
  var closeX = box.querySelector('.gv-x');

  var KEY  = 'obee-giveaway';
  var seen = '';
  try { seen = localStorage.getItem(KEY) || ''; } catch (e) {}

  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  /* ---------- Öffnen und Schliessen ---------- */
  function open() {
    box.hidden = false;
    document.body.classList.add('gv-open');
    requestAnimationFrame(function () { box.classList.add('on'); });
    if (reopen) reopen.hidden = true;
    var f = (tform || form) && (tform || form).querySelector('input');
    /* Auf dem Handy nicht automatisch fokussieren: die Tastatur
       würde hochfahren und das halbe Fenster verdecken. */
    if (f && window.innerWidth > 900) setTimeout(function () { f.focus(); }, 420);
  }

  function close() {
    box.classList.remove('on');
    document.body.classList.remove('gv-open');
    setTimeout(function () { box.hidden = true; }, 500);
    if (seen !== 'done') { remember('closed'); seen = 'closed'; }
    if (reopen && seen !== 'done') reopen.hidden = false;
  }

  if (closeX) closeX.addEventListener('click', close);
  if (reopen) reopen.addEventListener('click', open);
  box.addEventListener('click', function (e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !box.hidden) close();
  });

  /* ---------- Teilnahmebedingungen aufklappen ----------
     Der Link steht in beiden Formularen, deshalb delegiert. */
  box.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.gv-terms-link') : null;
    if (!t || !terms) return;
    e.preventDefault();
    terms.hidden = !terms.hidden;
    if (!terms.hidden) terms.scrollIntoView({ block: 'nearest' });
  });

  /* ---------- Endkundenteil auf- und zuklappen ----------
     Die Verlosung richtet sich zuerst an den Handel, dessen Formular
     steht offen. Der Weg für Privatpersonen hängt darunter und wird
     nur aufgeklappt, wenn jemand ihn braucht. */
  var toggle = box.querySelector('.gv-alt .toggle');
  if (toggle && form) {
    toggle.addEventListener('click', function () {
      var isOpen = form.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        var first = form.querySelector('input[type=email]');
        if (first && window.innerWidth > 900) first.focus();
        /* Das Fenster wächst — den neuen Teil in den Blick holen. */
        setTimeout(function () {
          if (card) card.scrollTop = card.scrollHeight;
        }, 620);
      }
    });
  }

  /* ---------- Wann es erscheint ---------- */
  var forced = /[?&]giveaway=1/i.test(window.location.search);

  if (seen === 'done' && !forced) {
    return;                               /* schon teilgenommen — Ruhe */
  }
  if (seen === 'closed' && !forced) {
    if (reopen) reopen.hidden = false;    /* nur der kleine Knopf */
  } else if (forced) {
    open();
  } else {
    /* Erst wenn die Altersabfrage durch ist, dann vier Sekunden. */
    var waited = 0;
    var tick = setInterval(function () {
      waited += 250;
      if (!document.body.classList.contains('gate-open')) {
        clearInterval(tick);
        setTimeout(open, 4000);
      } else if (waited > 120000) {
        clearInterval(tick);             /* niemand da — nicht ewig warten */
      }
    }, 250);
  }

  /* ---------- Absenden ---------- */
  var sink = document.createElement('iframe');
  sink.name = 'obee-sink-gv';
  sink.setAttribute('aria-hidden', 'true');
  sink.setAttribute('tabindex', '-1');
  sink.style.cssText = 'position:absolute;width:0;height:0;border:0;left:-9999px';
  document.body.appendChild(sink);

  function thanks(kicker, line) {
    remember('done'); seen = 'done';
    if (reopen) reopen.hidden = true;
    if (!card) return;
    card.classList.add('gv-sent');
    card.innerHTML =
      '<button type="button" class="gv-x" aria-label="Close">&times;</button>' +
      '<p class="gv-kick">' + kicker + '</p>' +
      '<h2 class="gv-h">Check your<br>inbox</h2>' +
      '<p class="gv-prize">' + line + '</p>' +
      '<p class="gv-note"><strong>Your entry only counts once you click it.</strong> ' +
      'Do it now — it takes five seconds and you are in the draw.</p>';
    var x = card.querySelector('.gv-x');
    if (x) x.addEventListener('click', close);
  }

  function wire(f, kicker, line) {
    if (!f || !f.getAttribute('action')) return;
    f.setAttribute('target', sink.name);

    var msg  = f.querySelector('.join-msg');
    var btn  = f.querySelector('button[type=submit]');
    var sent = false;

    function say(kind, text) {
      if (!msg) return;
      msg.className = 'join-msg ' + kind;
      msg.textContent = text;
    }

    f.addEventListener('submit', function (ev) {
      if (sent) { ev.preventDefault(); return; }

      var mail = f.querySelector('input[type=email]');
      var ok   = f.querySelector('.gv-check input[type=checkbox]');

      /* Pflichtfelder zuerst — beim Händlerformular sind es sechs. */
      var missing = null;
      Array.prototype.forEach.call(f.querySelectorAll('input[required]'), function (el) {
        if (missing || el.type === 'checkbox') return;
        if (!el.value.trim()) missing = el;
      });
      if (missing) {
        ev.preventDefault();
        say('err', 'Please fill in ' +
          (missing.getAttribute('placeholder') || 'all fields').toLowerCase());
        missing.focus();
        return;
      }
      if (!mail || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail.value.trim())) {
        ev.preventDefault();
        say('err', 'Enter a valid email address');
        if (mail) mail.focus();
        return;
      }
      if (ok && !ok.checked) {
        ev.preventDefault();
        say('err', 'Please confirm your age and the terms of entry');
        return;
      }

      sent = true;
      say('', 'Sending…');
      if (btn) { btn.disabled = true; btn.textContent = '…'; }

      var onLoad = function () {
        sink.removeEventListener('load', onLoad);
        thanks(kicker, line);
      };
      sink.addEventListener('load', onLoad);
      setTimeout(function () {
        if (!card || !card.classList.contains('gv-sent')) onLoad();
      }, 6000);
    });
  }

  wire(tform, 'Almost there',
       'We just sent a confirmation link to your business address.');
  wire(form, 'Almost there', 'We just sent you a confirmation link.');
})();
